import styled from 'styled-components'
import { rem } from 'polished'

interface IconPlaceholderProps {
  /**
   * Size of the icon in pixels (default: 24)
   */
  size?: number
}

/**
 * Placeholder component to maintain consistent height/spacing
 * where an icon might conditionally be shown
 */
const IconPlaceholder = styled.div<IconPlaceholderProps>`
  width: ${({ size = 24 }) => rem(size)};
  height: ${({ size = 24 }) => rem(size)};
`

export default IconPlaceholder
